const Unit = {

    // FIELDS
    "unit_no": "Unit Number",
    "area": "Area (Sq. ft.)",
    "bedroom": "Bedroom",
    "hall": "Hall",
    "kitchen": "Kitchen",
    "penthouse": "Penthouse",
    "open_terrace_area": "Open Terrace Area",
    "closed_terrace_area": "Closed Terrace Area",
    "fully_enclosed_terrace": "Fully Enclosed Terrace",
    "search": "Search",

    // PAGE HEADER
    "unit": "Unit",
    "units": "Units",

    // ERROR
    "error_unit_no": "Enter Unit Number",
    "error_area": "Enter Area",
    "error_negative": "Value cannot be negative",
    "error_penthouse": "Select Penthouse",
    "error_open_terrace_area": "Enter Open Terrace Area",
    "error_closed_terrace_area": "Enter Closed Terrace Area",
    "error_fully_enclosed_terrace": "Enter Fully Enclosed Terrace",
    "error_any_terrace_area": "Enter at least one terrace area",

    // TABLE HEADER

}

export default Unit;